import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";
import { pagePadding } from "../styles/constants";
import insertCc8Header from "../utils/insertCc8Header";
import Cc8Header from "./Cc8Header";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  ${pagePadding};
`;

export const ControlCenterContainer = ({
  children
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    insertCc8Header();
  }, []);
  return (
    <StyledContainer>
      <Cc8Header />
      <StyledInnerContainer>{children}</StyledInnerContainer>
    </StyledContainer>
  );
};
